import axios from "axios";
import { API_URL, getHeaderWithAuthorization } from "./API";

// Тип ошибки от бэкенда
interface ApiErrorResponse {
	name?: string;
	message?: string;
}

/**
 * Извлекает сообщение об ошибке из ответа API
 */
const extractErrorMessage = (error: unknown): string => {
	if (axios.isAxiosError(error) && error.response?.data) {
		const data = error.response.data as ApiErrorResponse;
		if (data.message) return data.message;
	}
	if (error instanceof Error) return error.message;
	return "Неизвестная ошибка";
};

// Константы ProctorEdu из переменных окружения
export const PROCTOR_URL = process.env.REACT_APP_PROCTOR_URL || 
	"https://svetofor.proctoring.online";
export const PROCTOR_PROVIDER = "jwt";

// Лимит попыток по умолчанию
export const PROCTOR_ATTEMPTS_LIMIT = Number(
	process.env.REACT_APP_PROCTOR_ATTEMPTS_LIMIT
) || 3;

// Ссылка на Telegram менеджера для сброса попыток
export const PROCTOR_TELEGRAM_LINK = process.env.REACT_APP_PROCTOR_TELEGRAM_LINK ||
	"https://t.me/pddtv_manager";

// Типы ответов API
export interface ProctorTokenResponse {
	token: string;
	proctoring_identifier: string;
}

export interface ProctorStatResponse {
	total: number;
}

export interface ProctorAttemptsResponse {
	total_attempts: number;
	used_attempts: number;
	remaining_attempts: number;
	is_blocked: boolean;
}

/**
 * Получение JWT токена для инициализации сессии прокторинга
 */
export const getProctorToken = async (): Promise<ProctorTokenResponse> => {
	try {
		const response = await axios.post<ProctorTokenResponse>(
			`${API_URL}v2/proctoring/token`,
			{},
			{ headers: getHeaderWithAuthorization() }
		);
		return response.data;
	} catch (error) {
		throw new Error(extractErrorMessage(error));
	}
};

/**
 * Получение статистики попыток пользователя
 */
export const getProctorStat = async (): Promise<ProctorStatResponse> => {
	const response = await axios.get<ProctorStatResponse>(
		`${API_URL}v2/proctoring/stat`,
		{ headers: getHeaderWithAuthorization() }
	);
	return response.data;
};

/**
 * Получение информации о попытках пользователя
 * Вычисляет оставшиеся попытки на основе статистики
 */
export const getProctorAttempts = async (): Promise<ProctorAttemptsResponse> => {
	const stat = await getProctorStat();
	const usedAttempts = stat.total;
	const remainingAttempts = Math.max(0, PROCTOR_ATTEMPTS_LIMIT - usedAttempts);
	
	return {
		total_attempts: PROCTOR_ATTEMPTS_LIMIT,
		used_attempts: usedAttempts,
		remaining_attempts: remainingAttempts,
		is_blocked: remainingAttempts <= 0,
	};
};






